export enum SelectedBoxState {
    newBox,
    existingBox
}